<!-- 工具题提示 -->
<div class="tipText" *ngIf="page==='answer' && exerciseType === 5 && question['toolsHomeworkFlag']">
  <img src="{{assetsRoute}}/picture/camp/blue_tip.png" alt="">
  <span>你可以到电脑端，使用在线表格编辑</span>
</div>
<!--标题-->
<div class="question-title-wrap {{page}}" *ngIf="tabNum != 1" [ngClass]="{'marginTop':page==='answer' && exerciseType === 5 && question['toolsHomeworkFlag']}">
  <div class="question-title">
    <p><span [innerHTML]="workType[exerciseType - 1] "></span></p>
    <span class="title-content" [innerHTML]="question['stem']"></span>
  </div>
</div>

<!-- 作答完成展示页面 -->
<div class="question-show-wrap question-show-wrap-{{page}}" *ngIf="page === 'finish' || page === 'list'" >
<ng-container *ngIf="question['userAnswer']!==null">
  <div *ngIf="exerciseType === 1"  class="question-show-item" id="type-{{exerciseType}}">
    <pre >{{question['userAnswer']}}</pre>
  </div>
</ng-container>

  <div *ngIf="exerciseType === 5" id="type-{{exerciseType}}" [ngClass]="{ 'height0' :  page === 'answer' }" >
    <pre *ngIf="question['userAnswer']">{{question['userAnswer']}}</pre>
    <div class="question-upload-list" *ngIf="uploadList && uploadList.length > 0">
      <div class="upload-item" [ngStyle]="{'background': item['fileType'] === 1 ? 'url('+ item['fileUrl'] +') no-repeat' : 'white','background-size':item['fileType'] === 1 ? 'cover':'unset' }" *ngFor="let item of uploadList;let i=index"  (click)="showPreview(item['fileUrl'],item['fileType'])">
        <div class="item-file-name" *ngIf="item['fileType'] !== 1">
          <div *ngIf="!item.extend" class="file-icon"></div>
          <img *ngIf="item.extend" src="{{assetsRoute}}/picture/applicationTool/{{item.extend}}.png" class="tool-icon">
          <p class="file-name">{{item['fileName']}}</p>
        </div>
      </div>
    </div>
  </div>
</div>

<!--答题展现-->
<div class="question-answer-wrap answer-{{questionNo}}" [ngClass]=" page === 'answer'? 'active':'' " *ngIf="page==='answer'"  >
<!--  文本题-->
<component-textarea *ngIf="exerciseType === 1" [id]="questionNo" [type]="1" [questionId]="question['homeworkDuplicateId']" [textareaValue]="question['userAnswer']?question['userAnswer']:''" [isShowWordLimit]="exerciseType!==3" [maxLen]="exerciseType === 3 ? 9999 : 500" [placeholder]="'请输入你的答案...'" (outPutValue)="getTextareaComponentValue($event)"></component-textarea>

<!--  上传题-->
  <div class="question-answer-upload question-{{question['questionId']}}" *ngIf="exerciseType === 5">
    <div class="question-file">
      <div class="question-file-download" *ngIf="homeworkPdfList && homeworkPdfList.length > 0">
        <div class="file-item" *ngFor="let item of homeworkPdfList;let i=index" (click)="downloadPDF(item['path'])">
          <img src="{{assetsRoute}}/picture/camp/pdf.png" alt="">
          <span>{{item['name']}}</span>
        </div>
      </div>
      <div class="question-img-download" *ngIf="homeworkImgList && homeworkImgList.length > 0">
        <div class="img-item" *ngFor="let item of homeworkImgList;let i=index" (click)="showPreview(item['path'],1)">
          <img :src="{{item.path}}" alt="">
          <img src="{{assetsRoute}}/picture/camp/download_img.png" alt="">
        </div>
      </div>
      <div class="file-more" *ngIf="downloadType == 'pdf' || downloadType == 'img' || downloadType == 'all'">
        <div class="downward" *ngIf="isShowExpand == 'down'" (click) = "fileExpand()">
          <span>查看更多</span>
          <img src="{{assetsRoute}}/picture/camp/downward.png" alt="">
        </div>
        <div class="upward" *ngIf="isShowExpand == 'up'" (click) = "fileExpand()">
          <span>收拢</span>
          <img src="{{assetsRoute}}/picture/camp/upward.png" alt="">
        </div>
      </div>
    </div>
    <div class="question-upload-container">
      <component-textarea *ngIf="!question['toolsHomeworkFlag']" [id]="questionNo" [type]="5" [questionId]="question['homeworkDuplicateId']" [textareaValue]="question['userAnswer']?question['userAnswer']:''" [isShowWordLimit]="false" [maxLen]="9999" [placeholder]="'请输入你的答案...'" (outPutValue)="getTextareaComponentValue($event)"></component-textarea>
      <p class="question-upload-tips" *ngIf="isShowMsg && uploadList.length > 0"><span>如需在手机端上传附件作为答案，请先清空已编辑表单</span></p>
      <div class="question-upload-list">
        <ng-container  *ngIf="uploadList && uploadList.length > 0">
          <div class="upload-item" [ngStyle]="{'background': item['fileType'] === 1 ? 'url('+ item['fileUrl'] +') no-repeat' : 'white','background-size':item['fileType'] === 1 ? 'cover':'unset' }" *ngFor="let item of uploadList;let i=index"  (click)="showPreview(item['fileUrl'],item['fileType'])">
            <div class="delete-file" (click)="deleteFile(i)"></div>
            <div class="item-file-name" *ngIf="item['fileType'] !== 1">
              <div *ngIf="!item.extend" class="file-icon"></div>
              <img *ngIf="item.extend" src="{{assetsRoute}}/picture/applicationTool/{{item.extend}}.png" class="tool-icon">
              <p class="file-name">{{item['fileName']}}</p>
            </div>
          </div>
        </ng-container>

        <div class="add-step" *ngIf="(question['toolsHomeworkFlag'] && uploadList.length<1)|| (!question['toolsHomeworkFlag'] && uploadList.length < 10)" [ngClass]="{'disabled':uploadDisabled}" (click)="startUpload()">
          <img *ngIf="!uploadDisabled" src="{{assetsRoute}}/picture/camp/add.png" alt="">
          <img *ngIf="uploadDisabled" src="{{assetsRoute}}/picture/camp/add-disabled.png" alt="">
         <div style="text-align: center;">
          <b>上传文件</b>
          <p>（PDF或图片）</p>
         </div>
        </div>
      </div>

      <input style="position: absolute;opacity: 0;height: 0;width: 0;margin: 0;padding: 0" type="file" id="upload_input" (change)="uploadFile($event)"  />
    </div>

  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/app-home-work/home-work-item/item.component.html